import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon, ExternalLinkIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-blue-900 text-white pt-16 pb-8" data-id="element-449">
      <div className="container mx-auto px-4" data-id="element-450">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-451">
          {/* Company Info */}
          <div data-id="element-452">
            <div className="mb-4" data-id="element-453">
              <div className="relative" data-id="element-454">
                <span className="text-2xl font-bold text-white" data-id="element-455">
                  Elevate<span className="text-yellow-500" data-id="element-456">IT</span>
                </span>
                <span className="text-sm font-normal ml-0.5 text-blue-200" data-id="element-457">
                  .fr
                </span>
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-500 to-transparent" data-id="element-458"></div>
              </div>
            </div>
            <p className="text-blue-200 mb-4 max-w-xs" data-id="element-459">
              La 1ère plateforme française d'opportunités d'affaires en Afrique.
              Des appels d'offres vérifiés et actualisés en temps réel.
            </p>
            <div className="flex space-x-3" data-id="element-460">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-blue-800 flex items-center justify-center hover:bg-blue-700 transition-colors" aria-label="Facebook" data-id="element-461">
                <FacebookIcon size={18} data-id="element-462" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-blue-800 flex items-center justify-center hover:bg-blue-700 transition-colors" aria-label="Twitter" data-id="element-463">
                <TwitterIcon size={18} data-id="element-464" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-blue-800 flex items-center justify-center hover:bg-blue-700 transition-colors" aria-label="Instagram" data-id="element-465">
                <InstagramIcon size={18} data-id="element-466" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-blue-800 flex items-center justify-center hover:bg-blue-700 transition-colors" aria-label="LinkedIn" data-id="element-467">
                <LinkedinIcon size={18} data-id="element-468" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-469">
            <h3 className="text-lg font-semibold mb-4" data-id="element-470">Liens rapides</h3>
            <ul className="space-y-2" data-id="element-471">
              {[{
              name: 'Accueil',
              href: '/'
            }, {
              name: 'Fonctionnalités',
              href: '/#features'
            }, {
              name: 'Tarifs',
              href: '/#pricing'
            }, {
              name: 'Démonstration',
              href: '/#demo'
            }, {
              name: 'Témoignages',
              href: '/#testimonials'
            }, {
              name: 'Blog',
              href: '/blog'
            }].map(link => <li key={link.name} data-id="element-472">
                  <Link to={link.href} className="text-blue-200 hover:text-white transition-colors flex items-center" data-id="element-473">
                    <span className="mr-1" data-id="element-474">›</span> {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Resources */}
          <div data-id="element-475">
            <h3 className="text-lg font-semibold mb-4" data-id="element-476">Ressources</h3>
            <ul className="space-y-2" data-id="element-477">
              {[{
              name: "Centre d'aide",
              href: '/aide'
            }, {
              name: 'Guide utilisateur',
              href: '/guide'
            }, {
              name: 'FAQ',
              href: '/faq'
            }, {
              name: 'Webinaires',
              href: '/webinaires'
            }, {
              name: 'Partenaires',
              href: '/partenaires'
            }, {
              name: 'API Documentation',
              href: '/api-docs'
            }].map(link => <li key={link.name} data-id="element-478">
                  <Link to={link.href} className="text-blue-200 hover:text-white transition-colors flex items-center" data-id="element-479">
                    <span className="mr-1" data-id="element-480">›</span> {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-481">
            <h3 className="text-lg font-semibold mb-4" data-id="element-482">Contact</h3>
            <ul className="space-y-3" data-id="element-483">
              <li className="flex items-start" data-id="element-484">
                <MapPinIcon size={18} className="text-yellow-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-485" />
                <span className="text-blue-200" data-id="element-486">
                  123 Avenue des Champs-Élysées
                  <br data-id="element-487" />
                  75008 Paris, France
                </span>
              </li>
              <li className="flex items-center" data-id="element-488">
                <PhoneIcon size={18} className="text-yellow-500 mr-2 flex-shrink-0" data-id="element-489" />
                <span className="text-blue-200" data-id="element-490">+33 7 53 29 34 19</span>
              </li>
              <li className="flex items-center" data-id="element-491">
                <MailIcon size={18} className="text-yellow-500 mr-2 flex-shrink-0" data-id="element-492" />
                <a href="mailto:contact@elevateit.fr" className="text-blue-200 hover:text-white transition-colors" data-id="element-493">
                  contact@elevateit.fr
                </a>
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-blue-800" data-id="element-494">
              <p className="text-sm text-blue-200" data-id="element-495">
                Heures d'ouverture: Lun-Ven, 9h-18h
              </p>
            </div>
          </div>
        </div>
        {/* Newsletter */}
        <div className="bg-blue-800 rounded-xl p-6 mb-12" data-id="element-496">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center" data-id="element-497">
            <div className="md:col-span-2" data-id="element-498">
              <h3 className="text-xl font-bold mb-2" data-id="element-499">
                Restez informé des nouvelles opportunités
              </h3>
              <p className="text-blue-200" data-id="element-500">
                Inscrivez-vous à notre newsletter pour recevoir les dernières
                actualités et offres spéciales.
              </p>
            </div>
            <div data-id="element-501">
              <form className="flex" data-id="element-502">
                <input type="email" placeholder="Votre email" className="flex-1 px-4 py-2 rounded-l-lg text-gray-900 focus:outline-none" aria-label="Adresse email pour la newsletter" data-id="element-503" />
                <button type="submit" className="bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-medium px-4 py-2 rounded-r-lg transition-colors" data-id="element-504">
                  S'inscrire
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* Bottom footer */}
        <div className="border-t border-blue-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-505">
          <p className="text-sm text-blue-200 mb-4 md:mb-0" data-id="element-506">
            &copy; {currentYear} ElevateIT. Tous droits réservés.
          </p>
          <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2" data-id="element-507">
            <Link to="/mentions-legales" className="text-sm text-blue-200 hover:text-white transition-colors" data-id="element-508">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="text-sm text-blue-200 hover:text-white transition-colors" data-id="element-509">
              Politique de confidentialité
            </Link>
            <Link to="/cgv" className="text-sm text-blue-200 hover:text-white transition-colors" data-id="element-510">
              CGV
            </Link>
            <Link to="/cookies" className="text-sm text-blue-200 hover:text-white transition-colors" data-id="element-511">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}